import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Story } from "@/components/Story";
import { Products } from "@/components/Products";
import { Origin } from "@/components/Origin";
import { FarmToTable } from "@/components/FarmToTable";
import { Lifestyle } from "@/components/Lifestyle";
import { Signup } from "@/components/Signup";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Imprint, Impressum, Privacy, Terms } from "@/components/Legal";

const Landing = () => (
  <div className="App bg-[#faf7f2] text-[#1a3626] min-h-screen">
    <Header />
    <main>
      <Hero />
      <Story />
      <Products />
      <Origin />
      <FarmToTable />
      <Lifestyle />
      <Signup />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/imprint" element={<Imprint />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
